import React from "react";

function StudentPass() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">Student Pass</h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            Kindly Visit Seva Sindhu Portal to apply for Student Pass
          </h5>
          <span className="new-blue">NEW</span>
        </div>
        <div className="letters-color-section-sub-heading-section">
          <span>Click Here</span>
          <h5 className="letters-color-section-sub-heading">
            to Visit Seva Sindhu Portal
          </h5>
        </div>
      </div>
    </div>
  );
}

export default StudentPass;
